import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import api, { getFileUrl } from '../../lib/api';

export const HeroSliderV5 = ({ projects = [] }) => {
  const [items, setItems] = useState(projects);

  useEffect(() => {
    if (projects.length === 0) {
      api.get('/projects?featured=true').then(r => setItems(r.data)).catch(() => {});
    }
  }, [projects]);

  if (items.length === 0) return (
    <div className="w-full py-20 bg-secondary">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center">
        <p className="text-muted-foreground">Henüz öne çıkan proje eklenmemiş</p>
      </div>
    </div>
  );

  return (
    <div className="w-full py-14 md:py-20" data-testid="home-hero-carousel-v5">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight mb-3">Projelerimiz</h2>
          <div className="w-12 h-0.5 bg-[hsl(var(--gold))] mx-auto" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.slice(0, 6).map((p, i) => (
            <Link key={p.id || i} to={`/proje/${p.slug}`} className="group relative rounded-2xl overflow-hidden bg-card border border-border shadow-[var(--shadow-elev-1)] hover:border-[hsl(var(--gold)/0.45)] transition-colors">
              <div className="aspect-[4/3] overflow-hidden">
                {p.cover_image ? <img src={getFileUrl(p.cover_image)} alt={p.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" /> : <div className="w-full h-full bg-secondary" />}
              </div>
              <div className="p-5">
                <span className="text-3xl font-heading font-bold text-[hsl(var(--gold))] tabular-nums">{String(i+1).padStart(2,'0')}</span>
                <h3 className="font-heading font-semibold text-base mt-2">{p.title}</h3>
                {p.subtitle && <p className="text-xs text-muted-foreground mt-1">{p.subtitle}</p>}
                <span className="inline-flex items-center gap-1 text-sm font-medium text-[hsl(var(--gold))] mt-3 group-hover:gap-2 transition-all">
                  {p.button_text || 'İncele'} <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};
